import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

function SmallButton(_ref, _ref2) {
  var bsStyle = _ref.bsStyle,
      disabled = _ref.disabled,
      label = _ref.label,
      name = _ref.name;
  var form = _ref2.form;

  var disable = disabled || name === 'submit' && form.getErrors().length > 0;

  return React.createElement(
    'div',
    { className: 'BlockButton' },
    React.createElement(
      Button,
      {
        bsStyle: bsStyle || 'success',
        disabled: disable,
        onClick: function onClick() {
          return form.set(name, true);
        }
      },
      label
    )
  );
}

SmallButton.contextTypes = {
  form: PropTypes.object.isRequired
};

SmallButton.propTypes = process.env.NODE_ENV !== "production" ? {
  bsStyle: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired
} : {};

export default SmallButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/SmallButton.js
// module id = 720
// module chunks = 0